import React from 'react'
import { connect } from 'react-redux'
import { fetchTodolists } from "../../actions/todolistActions"
import { fetchTodos } from "../../actions/todoActions"
import TodolistsForm from '../todo/TodolistsForm'

class SetsTodolist extends React.Component {

  componentWillMount(){
    this.props.fetchTodos({order_id: 0});
    this.props.fetchTodolists({order_id: 0});
  }

  render() {
    return(
      <TodolistsForm
        order={{order_id: 0}}
      />
    );
  }
}

export default connect(null, { fetchTodolists, fetchTodos })(SetsTodolist);



// WEBPACK FOOTER //
// ./src/components/settings/SetsTodolist.js